import { Component } from '@angular/core';

@Component({
  selector: 'app-meter-index',
  template: ``,
  styleUrls: []
})
export class MeterIndexComponent {

}
